import AppRouter from './AppRouter';

const App: React.FC = () => {
  return <AppRouter />;
};

export default App; 